import { faUtensils } from '@fortawesome/pro-regular-svg-icons/faUtensils';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { faVideo } from '@fortawesome/pro-regular-svg-icons/faVideo';
import { faBook } from '@fortawesome/pro-regular-svg-icons/faBook';
import { faMap } from '@fortawesome/pro-regular-svg-icons/faMap';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faGrid2 } from '@fortawesome/pro-solid-svg-icons/faGrid2';
import { faArrowProgress } from '@fortawesome/pro-regular-svg-icons/faArrowProgress';
import { faAddressCard } from '@fortawesome/pro-regular-svg-icons/faAddressCard';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';

export const TOUR_STEPS = [
  {
    title: 'Welcome to the Weekly Guide!',
    content: 'Each week a new guide is released with action items, recipes and resources covering a specific topic.',
    target: 'body',
    placement: 'center'
  },
  {
    title: 'Action Of The Week',
    content:
      "Each week you'll see a new Action Of The Week video. You can enable closed captioning by clicking the CC button once the video starts playing.",
    target: '#wlc-week-video',
    placement: 'auto'
  },
  {
    target: '#wlc-week-recipes-list > div:first-child',
    title: 'Recipes',
    content: 'You will see 6 recipes on each Weekly Guide page. Click on an image to see that particular recipe.',
    placement: 'auto'
  },
  {
    target: '#wlc-week-resources',
    title: 'Resources',
    content:
      "Check this section out each week to see the additional materials we've provided to help you get the most out of the week's topic.",
    placement: 'auto'
  },
  {
    target: '.post-form',
    title: 'Post a comment',
    content: 'Post your answer to the weekly question and other takeaways in a new comment box here.',
    placement: 'auto'
  }
];

export const SERVICES = {
  WEEKLY_GUIDE: 'weekly_guide',
  WEEK: 'week'
};

export const CONTENT_TYPES = {
  VIDEO: 'video',
  CHECKLIST: 'checklist',
  RECIPES_LIST: 'recipesList',
  RESOURCES_LIST: 'resourcesList'
};

export const GETTING_STARTED_SLUG = 'getting-started';

export const GETTING_STARTED_RESOURCES = [
  {
    displayProps: {
      title: 'Weekly Guide',
      description: 'This is your home base. Your weekly recipes, resources, action items, and more all live here.',
      icon: faMap
    },
    slug: 'current-week'
  },
  {
    displayProps: {
      title: 'All Recipes',
      description:
        'When you explore all recipes, you can browse by meal type, ingredient, or just scroll and see what catches your eye.',
      icon: faUtensils
    },
    slug: 'recipes'
  },
  {
    displayProps: {
      title: 'Live Events',
      description:
        'You can register for upcoming live events, such as expert interviews, in-the-kitchen events, and much more.',
      icon: faCalendar
    },
    slug: 'https://frn.co/wlc-zoom-hub',
    type: 'ExternalLink',
    data: {
      url: 'https://frn.co/wlc-zoom-hub'
    }
  },
  {
    displayProps: {
      title: 'Forum',
      description: 'Connect with your community in different channels organized by category.',
      icon: faUsers
    },
    slug: 'community'
  },
  {
    displayProps: {
      title: 'Favorites Library',
      description: 'Bookmark and save your favorite recipes, and easily come back to them here.',
      icon: faHeart
    },
    slug: 'favorites-library'
  },
  {
    displayProps: {
      title: 'All Resources',
      description: 'Find every WHOLE Life Club resource here. These resources are used across all tracks.',
      icon: faBook
    },
    slug: 'resources'
  },
  {
    displayProps: {
      title: 'All Action Hours',
      description: 'Explore past Action Hour interviews with doctors, nutritionists, and other experts.',
      icon: faVideo
    },
    slug: 'action-hours'
  },
  {
    displayProps: {
      title: 'Health Track Planner',
      description: 'Preview what’s up next in your current track and update your health track plan.',
      icon: faArrowProgress
    },
    slug: 'current-track'
  } /*
  {
    displayProps: {
      title: 'Settings & Preferences',
      description: 'Manage your profile, subscription, payment plan, password, and preferences.',
      icon: faUtensils
    }
  },
  {
    displayProps: {
      title: 'Support',
      description: 'Get instant answers to your questions or reach out directly to our support team.',
      icon: faUtensils
    }
  },*/,
  {
    displayProps: {
      title: 'View All Products',
      description: 'View all of your Food Revolution Network products in your Member Center home.',
      icon: faGrid2
    },
    slug: 'products',
    type: 'InternalLink'
  }
];

export const GETTING_STARTED_TUTORIAL_VIDEO_URL =
  'https://customer-ros8xhsmbkksflna.cloudflarestream.com/105df3725765e52d6d2bd1dbcd533d6e/watch';
